import ControlCenterIcon from './component'

export default ControlCenterIcon
